module.exports = __webpack_public_path__ + "static/media/barrierDoorhun.22ec6c89.jpeg";